export const CHECKOUT_URL = 'https://english-teacher-pro.impultienda.ar/checkout'

export const BOX_IMAGE =
  'https://cdn.magicpatterns.com/uploads/1jd1ZwWMefGHvLdrgcmK1j/Diseno-sin-titulo-2.webp'

export const CTA_LABEL = '🚀 SÌ! VOGLIO ENGLISH TEACHER PRO™ ORA'

export const RATING_LINE = '⭐⭐⭐⭐⭐ 4.9/5 — Valutato dagli Insegnanti'

export const GUARANTEE_LINE =
  '🛡️ Garanzia Soddisfatti o Rimborsati di 14 Giorni — Zero Rischi'
